import Axios from "axios";

const testImageExists = async (imageUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(imageUrl);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
};
const tvLogin = async (token) => {
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await Axios.post(`/api/users/tv-login`, {}, config);
  if (response.data.isLoggedIn) {
    return response.data.authKey;
  }
};

export { testImageExists, tvLogin };
